const bundle_inputs = document.querySelectorAll(".selected-bundle-product");
const addToCartBtnBundle = document.querySelector("#addToCartBundleBtn");
const subscriptionInputsBundle = document.querySelectorAll(".bundle_purchase-options input");

function makeBundleProductsPayload(selling_plan){
    const bundle_id = document.querySelector(".bundle").dataset.bundle_id;

    let note = ""
    bundle_inputs.forEach((input,i) =>{
      const productName = input.dataset.selected_name;
      if(i < bundle_inputs.length - 1){
      note += productName + ", "
      }else{
        note += productName
      }
    })
const payload = {
  id: bundle_id,
  quantity: 1,
  ...(selling_plan ? { selling_plan } : {}),
  properties: {
    "bundle_options": note
  }
}
    return payload
}
async function addSelectedBundleProducts(products) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(products)
      });

      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }

      const addData = await response.json();
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error('Failed to retrieve shopping cart data');
      }
window.location.href = '/cart';

    } catch (error) {
      console.error('Ошибка:', error);
      alert('Error adding products');
    }
  }

function getBundleSellingPlan(){
  if(subscriptionInputs){
    const selectedInput = [...subscriptionInputsBundle].find(input => input.checked);
    if(!selectedInput) return
    if(selectedInput.id === "bundle_one-time") return
    
    const selling_plan = document.querySelector(".bundle_selected-subscription").dataset.selected_id
    return selling_plan;
  }
}


document.querySelectorAll('.bundle-product-dropdown').forEach(select => {
    const selected = select.querySelector('.selected-bundle-product');
    const selectedText = select.querySelector('.selected-bundle-product span');
    const options = select.querySelector('.bundle-product_options');
    
    selected.addEventListener('click', () => {
      const isOpen = select.getAttribute('data-open') === 'true';
      select.setAttribute('data-open', !isOpen);
    });
    
    options.querySelectorAll('.bundle-product-variant').forEach(option => {
      option.addEventListener('click', () => {
        selectedText.textContent = option.textContent;
        selected.dataset.selected_id = option.dataset.id
        selected.dataset.selected_name = option.dataset.name
        const image = select.closest(".bundle-product_container").querySelector('.bundle-product_image-container img')
        image.src = option.dataset.image
        select.setAttribute('data-open', 'false');
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!select.contains(e.target)) {
        select.setAttribute('data-open', 'false');
      }
    });
  });
  const selectBundlePlanDropdown = document.querySelector(".bundle_subscriptions_dropdown_container")
    const selectedBundlePlan = selectBundlePlanDropdown.querySelector('.bundle_selected-subscription');
    const selectedBundlePlanText = selectBundlePlanDropdown.querySelector('.bundle_selected-subscription span');
    const bundleOptionsPlan = selectBundlePlanDropdown.querySelector('.bundle_subscription_options');
    
    selectBundlePlanDropdown.addEventListener('click', () => {
      const isOpen = selectBundlePlanDropdown.getAttribute('data-open') === 'true';
      selectBundlePlanDropdown.setAttribute('data-open', !isOpen);
    });
    
    bundleOptionsPlan.querySelectorAll('.bundle_product-subscription').forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        selectedBundlePlanText.textContent = option.textContent;
        selectedBundlePlan.dataset.selected_id = option.dataset.id
        selectBundlePlanDropdown.setAttribute('data-open', 'false');
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!selectBundlePlanDropdown.contains(e.target)) {
        selectBundlePlanDropdown.setAttribute('data-open', 'false');
      }
    });
addToCartBtnBundle.addEventListener("click",async () => {
    const payload = makeBundleProductsPayload(getBundleSellingPlan());
  console.log(payload)
    await addSelectedBundleProducts(payload)
})
